import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import * as clevertapKyb from 'clevertap/kyb';
import Modal from './Modal';
import styles from './style.css';

let BusinessEntityForm = class BusinessEntityForm extends React.Component {
  constructor(props) {
    super(props);
    if (props.data.kybForm.kybData) {
      this.initializeForm();
    }
  }

  componentDidMount() {
    $('body').append($('#kybInfo'));
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
    };
    this.props.appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker('KYB Business Type Start', clevertapData);
  }

  componentWillUnmount() {
    $('#kybInfo').remove();
  }

  initializeForm() {
    const { business_entity_type } = this.props.data.kybForm.kybData;
    const initData = { businessEntity: business_entity_type };
    this.props.initialize(initData);
  }

  entitySelected = entity => {
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const trackingData = {
      email,
      phone,
      businessCategory,
      businessLocation,
    };
    this.props.appendBusinessOpeningClevertap(trackingData);
    if (entity === 'personal') {
      clevertapKyb.clevertapTracker(
        'KYB Business Type Personal Selected',
        trackingData
      );
    } else {
      clevertapKyb.clevertapTracker(
        'KYB Business Type Corporate Selected',
        trackingData
      );
    }
  };

  render() {
    const { BusinessEntityForm } = this.props.data.form;
    let businessEntityValue = null;
    try {
      businessEntityValue = BusinessEntityForm.values.businessEntity;
    } catch (error) {
      businessEntityValue = null;
    }
    const { handleSubmit } = this.props;
    const { editMode } = this.props.data.kybForm;
    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div className="col-md-8 col-md-offset-2">
            <h2>What is your business entity type?</h2>
            <label
              className={`${styles.radioBtn} ${
                businessEntityValue === 'personal' ? styles.selected : ''
              }`}
            >
              <span className={`${styles.title}`}>Personal</span>
              <Field
                name="businessEntity"
                component="input"
                type="radio"
                value="personal"
                onClick={() => this.entitySelected('personal')}
              />
              <span className={`${styles.checkmark}`}>{''}</span>
            </label>
            <label
              className={`${styles.radioBtn} ${
                businessEntityValue === 'corporate' ? styles.selected : ''
              }`}
            >
              <span className={`${styles.title}`}>Corporate</span>
              <Field
                name="businessEntity"
                component="input"
                type="radio"
                value="corporate"
                onClick={() => this.entitySelected('corporate')}
              />
              <span className={`${styles.checkmark}`}>{''}</span>
            </label>
          </div>
          <a
            href="#"
            className={`${styles.info}`}
            data-toggle="modal"
            data-target="#kybInfo"
          >
            What does this mean?
          </a>
          <div className={`col-md-8 col-md-offset-2 ${styles['flex-display']}`}>
            <div
              className={`col-md-12 col-sm-12 col-xs-12 ${styles['form-btn']}`}
            >
              <button
                className={`btn btn-primary btn-block`}
                disabled={businessEntityValue === null}
                type="submit"
              >
                {editMode ? 'Save Changes' : 'Next'}
              </button>
            </div>
          </div>
        </form>
        <Modal title="Your business entity type">
          <div className={`${styles['modal-content']}`}>
            <h3>Personal Business Entities</h3>
            <p>Businesses that are run by individuals.</p>
            <h3>Corporate Business Entities</h3>
            <p>Businesses that are under the following corporate types:</p>
            <p>
              CV, FA, Koperasi, Maatschap, PK, PMA, PMDN, Persekutuan Perdata,
              Perusahaan Umum (Perum), Perusahaan Jawatan(Perjan), PT, P.T.
              Tbk., UD, Yayasan
            </p>
          </div>
        </Modal>
      </div>
    );
  }
};

BusinessEntityForm = reduxForm({
  form: 'BusinessEntityForm',
})(BusinessEntityForm);

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(BusinessEntityForm);
